import type { AuthUrlParams } from '@sunrise-ui/composites';
import { Redirect, useGlobalSearchParams } from 'expo-router';
import React from 'react';

export default function RootScreen() {
  const { forceLogin, email } = useGlobalSearchParams<AuthUrlParams>();
  return (
    <Redirect
      href={{
        pathname: '/events',
        params: {
          forceLogin,
          email,
        },
      }}
    />
  );
}
